export const SET_DADOS_INICIAIAS_PF_DOCUMENTO = "SET_DADOS_INICIAIAS_PF_DOCUMENTO";
export const LOADING_DADOS_INICIAIAS_PF_DOCUMENTO = "LOADING_DADOS_INICIAIAS_PF_DOCUMENTO";
export const ERROR_DADOS_INICIAIAS_PF_DOCUMENTO = "ERROR_DADOS_INICIAIAS_PF_DOCUMENTO";

export const SET_DADOS_INICIAIAS_PF_ORGAOEMISSOR = "SET_DADOS_INICIAIAS_PF_ORGAOEMISSOR";
export const LOADING_DADOS_INICIAIAS_PF_ORGAOEMISSOR = "LOADING_DADOS_INICIAIAS_PF_ORGAOEMISSOR";
export const ERROR_DADOS_INICIAIAS_PF_ORGAOEMISSOR = "ERROR_DADOS_INICIAIAS_PF_ORGAOEMISSOR";
export const HANDLER_CHANGE_DADOS_INICIAIS_PF_ORGAOEMISSOR = "HANDLER_CHANGE_DADOS_INICIAIS_PF_ORGAOEMISSOR";

export const CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM = "CHANGE_DADOS_INICIAIAS_PF_VALUE_FORM";
export const HANDLER_CHANGE_DADOS_INICIAIS_PF_DOCUMENTO = "HANDLER_CHANGE_DADOS_INICIAIS_PF_DOCUMENTO";
export const HANDLER_CHANGE_DADOS_INICIAIS_PF_PAIS = "HANDLER_CHANGE_DADOS_INICIAIS_PF_PAIS";

export const SET_DADOS_INICIAIAS_PF_PAIS = "SET_DADOS_INICIAIAS_PF_PAIS";
export const LOADING_DADOS_INICIAIAS_PF_PAIS = "LOADING_DADOS_INICIAIAS_PF_PAIS";
export const ERROR_DADOS_INICIAIAS_PF_PAIS = "ERROR_DADOS_INICIAIAS_PF_PAIS";

export const LOADING_DADOS_INICIAIAS_PF_CPF = "LOADING_DADOS_INICIAIAS_PF_CPF";
export const SET_DADOS_INICIAIAS_PF_CPF = " SET_DADOS_INICIAIAS_PF_CPF";
export const ERROR_DADOS_INICIAIAS_PF_CPF = "ERROR_DADOS_INICIAIAS_PF_CPF";

export const LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE = "LOADING_DADOS_INICIAIAS_PF_CODIGO_GERENTE";
export const SET_DADOS_INICIAIAS_PF_CODIGO_GERENTE = "SET_DADOS_INICIAIAS_PF_CODIGO_GERENTE";
export const ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE = "ERROR_DADOS_INICIAIAS_PF_CODIGO_GERENTE";

export const LOADING_DADOS_INICIAIAS_PF_NOME_GERENTE = "LOADING_DADOS_INICIAIAS_PF_NOME_GERENTE";
export const SET_DADOS_INICIAIAS_PF_NOME_GERENTE = "SET_DADOS_INICIAIAS_PF_NOME_GERENTE";
export const ERROR_DADOS_INICIAIAS_PF_NOME_GERENTE = "ERROR_DADOS_INICIAIAS_PF_NOME_GERENTE";

export const SET_CODIGO_GERENTE_VIA_LINK = "SET_CODIGO_GERENTE_VIA_LINK";
export const SET_ID_DDIPAIS_DADOS_INICIAIS_PF = "SET_ID_DDIPAIS_DADOS_INICIAIS_PF";

